import ReactDOM from 'react-dom/client';
import { App } from '@app/index';
import '@/index.css';

ReactDOM.createRoot(document.getElementById('root')).render(<App />);
